/** Does a finding of this severity stop the quote? ``customer_decides`` stops
 *  it like ``block`` until the customer accepts the risk (KAN-2069/2070).
 *
 *  Kept out of ``@/api/queries/quotes`` on purpose: tests mock that module
 *  wholesale, and a pure helper living there vanished with the mock. */
export function isBlockingSeverity(severity: unknown): boolean {
  return severity === "block" || severity === "customer_decides";
}
